const gridChange = {
    btn: document.querySelectorAll('.jsGridChange'),
    grid: document.getElementById('productGrid'),

    init() {
        if(this.grid) {         
            this.changeGrid();
            this.setGrid();
        }
       
    },
    changeGrid() {
        this.btn.forEach((item, index)=>{
            item.addEventListener('click', ()=>{
                this.btn.forEach(el=>{
                     el.classList.remove('activeClass');
                     this.grid.classList.remove(el.dataset.class);
                 });

                item.classList.add('activeClass');
                this.grid.classList.add(item.dataset.class);
                localStorage.setItem('grid', index);
            })
        })
    },
    setGrid() {
        let index = localStorage.getItem('grid');
      
        if(index) {
            this.btn.forEach(el=>{
                el.classList.remove('activeClass');
                this.grid.classList.remove(el.dataset.class);
            });
            this.grid.classList.add(this.btn[index].dataset.class);
            this.btn[index].classList.add('activeClass');
        }
        
    }


}

export default gridChange;